import { RouteConfig } from 'vue-router';
import Layout from '@/layout/index.vue';

const paymentRouter: RouteConfig = {
  path: '/payment',
  component: Layout,
  redirect: '/payment/index',
  children: [
    {
      path: '/payment/index',
      name: 'Payment',
      component: () => import('@/views/payment/index.vue'),
      meta: {
        title: 'route.payment',
        icon: 'iconfukuan0',
        activeMenu: ['/payment/index'],
        breadcrumb: [
          {title: 'route.paymentList', path: '/payment/index'},
        ],
      },
    },
    {
      path: '/payment/create',
      name: 'CreatePayment',
      props: true,
      component: () => import('@/views/payment/createPayment.vue'),
      meta: {
        hidden: true,
        activeMenu: ['/payment/index'],
        title: 'route.createPayment',
        noCache: true,
        breadcrumb: [
          {title: 'route.paymentList', path: '/payment/index'},
          {title: 'route.createPayment', path: '/payment/create'},
        ],
      },
    },
    {
      path: '/payment/update',
      name: 'UpdatePayment',
      props: true,
      component: () => import('@/views/payment/updatePayment.vue'),
      meta: {
        hidden: true,
        activeMenu: ['/payment/index'],
        title: 'route.updatePayment',
        noCache: true,
        breadcrumb: [
          {title: 'route.paymentList', path: '/payment/index'},
          {title: 'route.updatePayment', path: '/payment/update'},
        ],
      },
    },
  ],
};

export default paymentRouter;
